import React from 'react'

import { Link } from 'gatsby'

import styles from './header.module.css'

const Header = () => (
  <header className={styles.demoHeader}>
    <h1 className={styles.demoHeaderTitle}>Gatsby Theme <span className={styles.blueText}>Docs</span></h1>
    <nav>
      <Link className={styles.demoHeaderLink} activeClassName={styles.blueText} to={"/"}>Home</Link>
      <Link className={styles.demoHeaderLink} activeClassName={styles.blueText} to={"/learn"}>Learn</Link>
    </nav>
  </header>
)

export default Header